import React from 'react';
import { DraggableDialog } from '@mummssoftware/common-ui';
import { DeleteVisitCheck } from './DeleteVisitCheck';
import defaults from '../../../translations/en.json';

type DeleteVisitCheckConfirmationProps = {
  open: boolean;
  setClosed: () => void;
  onDelete: () => void;
  data: Record<string, any>;
  isHopeVisit?: boolean;
};

export const DeleteVisitCheckConfirmation = ({
  open,
  setClosed,
  onDelete,
  data,
  isHopeVisit,
}: DeleteVisitCheckConfirmationProps) => (
  <DraggableDialog
    title={defaults.deleteVisitConfMsgTitle}
    handleClick={() => null}
    open={open}
    hideBackdrop
    noIcon
  >
    <DeleteVisitCheck
      data={data}
      isHopeVisit={isHopeVisit}
      setClosed={setClosed}
      onDelete={onDelete}
    />
  </DraggableDialog>
);
